<div class="main">
  <div class="list-button-container">
    <div class="buttonContainer">
      <button
        mat-flat-button
        color="accent"
        class="createNewDepartmentBtn"
        (click)="createNewDepartment()"
        >
        Ny Afdeling
      </button>
    </div>

    @if (!isHistory) {
      <div class="list-container">
        <lib-list-view
          [headerList]="headerList"
          #listView
          (rowClick)="departmentClicked($event)"
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
        ></lib-list-view>
      </div>
    }

    @if (isHistory) {
      <div class="list-container">
        <lib-list-view
          [headerList]="logHeaderList"
          #logListView
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
        ></lib-list-view>
      </div>
    }
  </div>
</div>
